<template lang="pug">
v-dialog(v-model="show", scrollable, v-if="listaOrdenada && listaOrdenada.length", width="50%", min-height="50%" max-height="70%")
    v-card
      v-card-title.title
        v-layout(column)
          v-flex.md12.pb-3
            span Selecione a loja
          v-flex.md12
            v-text-field(append-icon='search', outline, color="gray", label='Buscar loja', type="text", v-model="search", clearable, :hide-details="true")
      v-card-text
        v-layout(row, wrap)
          v-flex.md12
            v-list(three-line)
              template(v-for='(estabelecimento, i) in estabelecimentosVisiveis')
                v-list-tile(style="cursor:pointer;", @click="select(estabelecimento)")
                  v-list-tile-action
                    v-icon(:color="isAberto(estabelecimento) ? 'primary' : 'orange'", small).fa fa-circle
                  v-list-tile-content
                    v-list-tile-title.content-text {{ estabelecimento.nome }}
                    v-list-tile-sub-title.content-text {{estabelecimento.localidade}} - {{estabelecimento.estado}}
                      br
                      BadgeOrigem(:cardapio_digital="estabelecimento.cardapio_digital ? true : false", :label="true")

                  v-list-tile-action
                    v-icon(v-if="!estabelecimentoSelecionado || estabelecimentoSelecionado.id != estabelecimento.id")
                    v-icon(v-if="estabelecimentoSelecionado && estabelecimentoSelecionado.id == estabelecimento.id", color="primary").fa fa-check-circle
                v-divider(v-if="i < estabelecimentosVisiveis.length - 1")
              v-list-tile(v-if="totalRestante > 0", ref="sentinela", @click="mostrarMais()")
                v-list-tile-content
                  v-list-tile-title.text-xs-center.primary--text Mostrar mais {{ proximoPasso }} (restam {{ totalRestante }})
      v-card-actions
        v-spacer
        v-btn(@click="close()", flat) Fechar
        v-btn(depressed, @click="setTodas()", color="accent", :disabled="listaOrdenada.length == 1") Selecionar Todas

</template>

<script>
import _ from "lodash";
import BadgeOrigem from "@/components/BadgeOrigem";
import listaLojasIncremental from "@/mixins/listaLojasIncremental";


export default {
  mixins: [listaLojasIncremental],
  components: {
    BadgeOrigem
  },
  props: {
  },
  data () {
    return {
        show : false,
        loading: false,
        search: null,
        // aplicado com debounce: evita refiltrar a lista inteira a cada tecla
        searchAplicado: null,
        estabelecimentoSelecionado: null,
    }
  },
  created () {
    this.aplicarBusca = _.debounce(valor => {
      this.searchAplicado = valor;
      this.resetLimite();
    }, 200);
  },
  beforeDestroy() {
    if (this.aplicarBusca) this.aplicarBusca.cancel();
  },
  watch: {
    search (valor) {
      this.aplicarBusca(valor || null);
    },
  },
  computed: {
    listaOrdenada () {
      return _.sortBy(this.$root.estabelecimentos || [], 'nome');
    },
    estabelecimentos () {
      return this.$root.searchLojas(this.listaOrdenada, this.searchAplicado);
    },
  },
  methods: {
    open(estabelecimento){
      this.estabelecimentoSelecionado = estabelecimento;
      this.show = true;
      this.search = null;
      this.searchAplicado = null;
      this.resetLimite();
    },
    close(){
      this.show = false;
    },
    isAberto(estabelecimento){
      const delivery = estabelecimento.delivery ? estabelecimento.delivery[0] : null
      return delivery && delivery.aberto == 1 ? true : false;
    },
    refresh(estabelecimento){
      this.$emit('refresh', estabelecimento)
      window.getApp.$emit("CHANGE_ESTABELECIMENTO")
    },
    setTodas(){
      this.close();
      this.$store.dispatch('setEstabelecimentoSelecionado', null);
      this.refresh(null)
    },
    select(estabelecimento){
      this.estabelecimentoSelecionado = estabelecimento;
      this.close()
      this.$store.dispatch('setEstabelecimentoSelecionado', estabelecimento);
      this.refresh(this.estabelecimentoSelecionado)
    }
  }
  }
</script>

<style lang="scss" scoped>
.content-text{
  white-space: normal;
  word-wrap: break-word;
  height: auto;
}
</style>
